import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Graph = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M20.5 20.5H8.58333C5.00852 20.5 3.2211 20.5 2.11056 19.3895C1 18.2788 1 16.4914 1 12.9167V1'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M3.16797 19.4168C3.64396 15.9976 6.06742 7.24482 9.04852 7.24482C11.1089 7.24482 11.6425 11.4384 13.6616 11.4384C17.1355 11.4384 16.6319 2.0835 20.5013 2.0835'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Graph;
